import React, { useContext } from "react"
import { Link } from "@zestia/gatsby-plugin-react-i18next"
import { GatsbyImage, getImage } from "gatsby-plugin-image"
import { ImageWithTextBlockColumnsContext } from "@/context/imageWithTextBlockColumns"
import { gtmTracking } from "@/utils/gtm-tracking"
import { LuChevronRight } from "react-icons/lu"

const ImageWithTextBlock = ({
  image,
  kicker,
  title,
  titleLink,
  text,
  textCenter = false,
  className,
  supportingText,
  link,
  offerText,
  imageClassName = "",
  linkedAppearance = false,
  imageTop = false,
}) => {
  const { columnLayout } = useContext(ImageWithTextBlockColumnsContext) || {}
  const isTwoColumnLayout = columnLayout === 2
  const isImageBottom = isTwoColumnLayout && !imageTop
  const cardLink = link || titleLink
  const isLinkedCard = Boolean(cardLink)
  const hasLinkedAppearance = linkedAppearance
  const isHashLink = typeof cardLink === "string" && cardLink.startsWith("#")

  const handleLinkClick = event => {
    gtmTracking("Card Click", title, "Image With Text Block")()

    if (!isHashLink) return

    event.preventDefault()
    const element = document.querySelector(cardLink)

    if (element) {
      const navbarOffset = 77
      const elementTop =
        element.getBoundingClientRect().top + window.pageYOffset - navbarOffset

      window.scrollTo({
        top: elementTop,
        behavior: "smooth",
      })
    }
  }

  // eslint-disable-next-line no-console
  const imageContent = image && (
    <div className="image-text-block__image-container">
      <GatsbyImage
        className={`image-text-block__image ${
          isImageBottom ? "image-text-block__image--no-top-radius" : ""
        } ${imageClassName}`}
        image={getImage(image.src)}
        alt={image.alt}
        height={204}
      />
    </div>
  )

  const textContent = (
    <div
      className={`${
        textCenter ? "text-centered" : ""
      } image-text-block__text ${offerText ? "has-offer" : ""}`}
    >
      {kicker && (
        <span className="heading-kicker heading-kicker--no-status">
          {kicker}
        </span>
      )}
      {title ? (
        isLinkedCard ? (
          <div className="image-text-block__title-row">
            {columnLayout === 3 ? <h5>{title}</h5> : <h4>{title}</h4>}
            <LuChevronRight className="image-text-block__link-icon" />
          </div>
        ) : columnLayout === 3 ? (
          <h5>{title}</h5>
        ) : (
          <h4>{title}</h4>
        )
      ) : null}
      {text && <p>{text}</p>}
      {supportingText && <p>{supportingText}</p>}
    </div>
  )

  const offerContent =
    offerText && (
      <div className="offer-section">
        <p className="offer-section__text">{offerText}</p>
      </div>
    )

  const content = (
    <div
      className={`${
        hasLinkedAppearance ? "image-text-block__wrapper" : ""
      }`}
    >
      <div
        className={`image-text-block ${
          hasLinkedAppearance ? "image-text-block--linked" : ""
        } ${className}`}
      >
        {isImageBottom ? (
          <>
            {textContent}
            {offerContent}
            {imageContent}
          </>
        ) : (
          <>
            {imageContent}
            {textContent}
            {offerContent}
          </>
        )}
      </div>
    </div>
  )

  if (!cardLink) {
    return content
  }

  return cardLink.startsWith("http") ? (
    <a
      href={cardLink}
      className="image-text-block__link"
      target="_blank"
      rel="noopener noreferrer"
      onClick={handleLinkClick}
    >
      {content}
    </a>
  ) : (
    <Link
      to={cardLink}
      className="image-text-block__link"
      onClick={handleLinkClick}
    >
      {content}
    </Link>
  )
}

export default ImageWithTextBlock
